/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PlatformDTO
 */
export interface PlatformDTO {
  /**
   *
   * @type {number}
   * @memberof PlatformDTO
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof PlatformDTO
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof PlatformDTO
   */
  googleExperimentId: string;
  /**
   *
   * @type {number}
   * @memberof PlatformDTO
   */
  wctPlatformId: number;
  /**
   *
   * @type {string}
   * @memberof PlatformDTO
   */
  googleOptimizeId?: string;
  /**
   *
   * @type {string}
   * @memberof PlatformDTO
   */
  headerText?: string;
  /**
   *
   * @type {string}
   * @memberof PlatformDTO
   */
  navBarTitle?: string;
  /**
   *
   * @type {string}
   * @memberof PlatformDTO
   */
  navBarSubTitle?: string;
  /**
   *
   * @type {string}
   * @memberof PlatformDTO
   */
  navBarLink?: string;
  /**
   *
   * @type {string}
   * @memberof PlatformDTO
   */
  mailchimpApiKey?: string;
  /**
   *
   * @type {string}
   * @memberof PlatformDTO
   */
  mailchimpAudienceId?: string;
  /**
   *
   * @type {string}
   * @memberof PlatformDTO
   */
  merchantPrefix?: string;
  /**
   *
   * @type {string}
   * @memberof PlatformDTO
   */
  productPrefix?: string;
  /**
   *
   * @type {string}
   * @memberof PlatformDTO
   */
  alertMessage?: string;
  /**
   *
   * @type {string}
   * @memberof PlatformDTO
   */
  alertStartDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof PlatformDTO
   */
  alertEndDate?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof PlatformDTO
   */
  showAlert?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PlatformDTO
   */
  isOffline?: boolean;
  /**
   * No-deals grace period in days (empty = default)
   * @type {number}
   * @memberof PlatformDTO
   */
  productPageSyncGracePeriodDays?: number | null;
  /**
   * Cleanup-after-days (read-only constant)
   * @type {number}
   * @memberof PlatformDTO
   */
  readonly productPageSyncCleanupAfterDays?: number;
  /**
   * Min deals to create a page (read-only constant)
   * @type {number}
   * @memberof PlatformDTO
   */
  readonly productPageSyncMinDealsToCreatePage?: number;
  /**
   * Min deals to bring an offline page back online (read-only constant)
   * @type {number}
   * @memberof PlatformDTO
   */
  readonly productPageSyncMinDealsToBackOnline?: number;
  /**
   * Min deals to keep a page online (read-only constant)
   * @type {number}
   * @memberof PlatformDTO
   */
  readonly productPageSyncMinDealsToStayOnline?: number;
}

/**
 * Check if a given object implements the PlatformDTO interface.
 */
export function instanceOfPlatformDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "googleExperimentId" in value;
  isInstance = isInstance && "wctPlatformId" in value;

  return isInstance;
}

export function PlatformDTOFromJSON(json: any): PlatformDTO {
  return PlatformDTOFromJSONTyped(json, false);
}

export function PlatformDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlatformDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
    googleExperimentId: json["googleExperimentId"],
    wctPlatformId: json["wctPlatformId"],
    googleOptimizeId: !exists(json, "googleOptimizeId") ? undefined : json["googleOptimizeId"],
    headerText: !exists(json, "headerText") ? undefined : json["headerText"],
    navBarTitle: !exists(json, "navBarTitle") ? undefined : json["navBarTitle"],
    navBarSubTitle: !exists(json, "navBarSubTitle") ? undefined : json["navBarSubTitle"],
    navBarLink: !exists(json, "navBarLink") ? undefined : json["navBarLink"],
    mailchimpApiKey: !exists(json, "mailchimpApiKey") ? undefined : json["mailchimpApiKey"],
    mailchimpAudienceId: !exists(json, "mailchimpAudienceId") ? undefined : json["mailchimpAudienceId"],
    merchantPrefix: !exists(json, "merchantPrefix") ? undefined : json["merchantPrefix"],
    productPrefix: !exists(json, "productPrefix") ? undefined : json["productPrefix"],
    alertMessage: !exists(json, "alertMessage") ? undefined : json["alertMessage"],
    alertStartDate: !exists(json, "alertStartDate") ? undefined : json["alertStartDate"],
    alertEndDate: !exists(json, "alertEndDate") ? undefined : json["alertEndDate"],
    showAlert: !exists(json, "showAlert") ? undefined : json["showAlert"],
    isOffline: !exists(json, "isOffline") ? undefined : json["isOffline"],
    productPageSyncGracePeriodDays: !exists(json, "productPageSyncGracePeriodDays")
      ? undefined
      : json["productPageSyncGracePeriodDays"],
    productPageSyncCleanupAfterDays: !exists(json, "productPageSyncCleanupAfterDays")
      ? undefined
      : json["productPageSyncCleanupAfterDays"],
    productPageSyncMinDealsToCreatePage: !exists(json, "productPageSyncMinDealsToCreatePage")
      ? undefined
      : json["productPageSyncMinDealsToCreatePage"],
    productPageSyncMinDealsToBackOnline: !exists(json, "productPageSyncMinDealsToBackOnline")
      ? undefined
      : json["productPageSyncMinDealsToBackOnline"],
    productPageSyncMinDealsToStayOnline: !exists(json, "productPageSyncMinDealsToStayOnline")
      ? undefined
      : json["productPageSyncMinDealsToStayOnline"]
  };
}

export function PlatformDTOToJSON(value?: PlatformDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name,
    googleExperimentId: value.googleExperimentId,
    wctPlatformId: value.wctPlatformId,
    googleOptimizeId: value.googleOptimizeId,
    headerText: value.headerText,
    navBarTitle: value.navBarTitle,
    navBarSubTitle: value.navBarSubTitle,
    navBarLink: value.navBarLink,
    mailchimpApiKey: value.mailchimpApiKey,
    mailchimpAudienceId: value.mailchimpAudienceId,
    merchantPrefix: value.merchantPrefix,
    productPrefix: value.productPrefix,
    alertMessage: value.alertMessage,
    alertStartDate: value.alertStartDate,
    alertEndDate: value.alertEndDate,
    showAlert: value.showAlert,
    isOffline: value.isOffline,
    productPageSyncGracePeriodDays: value.productPageSyncGracePeriodDays
  };
}
